import Repository from '../axios'

const resource = "/admin/system_setting/customer/otif-target";

export default {
  getOtifTargets() {
    return Repository.get(`${resource}`)
  },
  getOtifTargetList() {
    return Repository.get(`${resource}`)
  },
  createOtifTarget(payload) {
    return Repository.post(`${resource}`, payload)
  },
  updateOtifTarget(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  },
  deleteOtifTarget(id) {
    return Repository.delete(`${resource}/${id}`)
  },
  getOtifReportData(payload = {}) {
    return Repository.request({
      method: 'GET',
      url: '/admin/report/otif-target-data',
      data: payload,
      params: payload
    })
  }
};
